import { render, staticRenderFns } from "./projectDetail.vue?vue&type=template&id=5617bc2c&scoped=true&"
import script from "./projectDetail.vue?vue&type=script&lang=js&"
export * from "./projectDetail.vue?vue&type=script&lang=js&"
import style0 from "./projectDetail.vue?vue&type=style&index=0&id=5617bc2c&prod&scoped=true&lang=scss&"
import style1 from "./projectDetail.vue?vue&type=style&index=1&id=5617bc2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5617bc2c",
  null
  
)

export default component.exports